import Vue from 'vue';
import _ from 'lodash';
import { guid } from '@/mixins/guid';

export default Vue.component('dynamic-input-custom-options', {
  template: require('./template.html'),
  name: 'dynamic-input-custom-options',
  mixins: [guid],
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-tab',
    'open-cropper',
  ],
  data() {
    return {
      display: {},
      showOptionTypes: false,
      selectedOption: 'none',
      optionTypes: [
        'select',
        'checkbox',
        'textarea',
      ],
    };
  },
  watch: {
    innerTabs: {
      handler(tab) {
        if (tab[this.dynamicTab]) {
          this.setInitialValues();
        }
      },
      deep: true,
    },
  },
  methods: {
    setInitialValues() {
      this.$set(this.display, this.type, this.activeItem[this.type] || []);
    },
    onTypeChange() {
      if (this.selectedOption !== 'none') {
        const items = [{
          value: false,
        }];
        if (this.selectedOption === 'select') {
          items[0].value = 'Option';
          items[0].limit = 1;
          items.push({
            value: 'Option',
            limit: 1,
          });
        }
        this.$store.dispatch('pushDropletVal', {
          array: this.activeItem[this.type],
          val: {
            _id: this.guid(),
            type: this.selectedOption,
            label: 'Label Here',
            items,
          },
        });
        this.showOptionTypes = false;
        this.selectedOption = 'none';
      }
    },
    removeOption(index) {
      this.$store.dispatch('spliceDropletVal', {
        array: this.activeItem[this.type],
        index,
      });
    },
    setOptionVal(e, option) {
      this._debounce(() => {
        const val = this._getInputVal(e.target.value);
        this.$store.dispatch('setDropletVal', {
          drp: option,
          key: 'label',
          val,
        });
      }, 200);
    },
    updateItemVal(e, item) {
      this._debounce(() => {
        const val = this._getInputVal(e.target.value);
        this.$store.dispatch('setDropletVal', {
          drp: item,
          key: 'value',
          val,
        });
      }, 200);
    },
    removeOptionItem(index, set) {
      this.$store.dispatch('spliceDropletVal', {
        array: set.items,
        index,
      });
    },
    addSetOptionItem(set) {
      this.$store.dispatch('pushDropletVal', {
        array: set.items,
        val: {
          value: 'Option',
          limit: 1,
        },
      });
    },
    addOption() {
      this.showOptionTypes = true;
    },
    cancelAdd() {
      this.showOptionTypes = false;
    },
    startCase(text) {
      return _.startCase(text);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/custom-options/index.js